// extracted by mini-css-extract-plugin
module.exports = {"center":"RecoveryEntry-RecoveryEntry-center-05380165"};